import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../Style/Footer.css';
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebook,
  FaYoutube,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

gsap.registerPlugin(ScrollTrigger);

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const footerRef = useRef(null);
  const columnsRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Stagger animation for footer columns - replays on each scroll
      gsap.fromTo(columnsRef.current,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.15,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: footerRef.current,
            start: 'top 90%',
            toggleActions: 'play none none none'
          }
        }
      );
    }, footerRef);

    return () => ctx.revert();
  }, []);

  const addToRefs = (el) => {
    if (el && !columnsRef.current.includes(el)) {
      columnsRef.current.push(el);
    }
  };
  
  return (
    <div>
      <footer className="footer" ref={footerRef}>
        <div className="footer-columns">
          {/* Column 1: Contact */}
          <div className="footer-column" ref={addToRefs}>
            <h2 className="footer-logo">
              <span className="red">Automotive</span>
              <span className="white">Devices</span>
            </h2>
            {/* <p><FaPhoneAlt /> <span>0300-8429331</span></p> */}
            <p><FaEnvelope /> <span>ali@automotivedevices.com</span></p>
            <p><FaMapMarkerAlt /> <span>Plot No. 66C to 68C</span></p>
            
            <div className="footer-socials">
              <div className="social-container">
                <a
                  href="https://www.facebook.com/automotivedevices/videos?ref=page_internal"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link facebook"
                >
                  <FaFacebook className="icon-inner" />
                </a>

                <a
                  href="https://www.youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link youtube"
                >
                  <FaYoutube className="icon-inner" />
                </a>
              </div>
            </div>
          </div>

          {/* Column 2: Company */}
          <div className="footer-column" ref={addToRefs}>
            <h3 className='headr'>COMPANY</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/mission">Mission</Link></li>
              <li><Link to="/customer-focus">Customer Focus</Link></li>
              <li><Link to="/product-focus">Product Focus & Expertise</Link></li>
              <li><Link to="/quality">Quality System</Link></li>
            </ul>
          </div>

          {/* Column 3: Services */}
          <div className="footer-column" ref={addToRefs}>
            <h3>Services & Capabilities</h3>
            <ul className="services-grid">
              <li><Link to="/service/PCB">PCB Design</Link></li>
              <li><Link to="/service/Fabrication">PCB Fabrication</Link></li>
              <li><Link to="/service/PCB">PCB Assembly</Link></li>
              <li><Link to="/service/Prototyping">Prototyping</Link></li>
              <li><Link to="/service/Prototyping">Introduction</Link></li>
              <li><Link to="/service/System">Box Build</Link></li>
              <li><Link to="/service/Supply">Quality Control</Link></li>
              <li><Link to="/service/Supply">Supply Chain</Link></li>
            </ul>
          </div>
        </div>
      </footer>

      <div className="footer-bottom">
        Copyright © {currentYear} ODM Company. All Rights Reserved
      </div>
    </div>
  );
};

export default Footer;